import { ArcadeMachineService } from '@/src/services/ArcadeMachineService'
import { useState } from 'react'
import { Props } from './Layout'
import { CraftCurrencyType, useCraftMutation } from './query.generated'
import { useLoginUser } from '../../states/LoginUser'
import { useRouter } from 'next/router'
import { PagePathService } from '@/src/services/PagePathService'
import { useGameInfo } from '../../states/Games'

export type Params = {
  parts: Props['parts']
  akvFee: number
  terasFee: number
  onCompleted: () => void
  onClickClose: () => void
}

export const useProps = ({ onCompleted, onClickClose, parts, akvFee, terasFee }: Params): Props => {
  const { games } = useGameInfo()
  const terasBalance = useLoginUser().loginUser?.terasBalance ?? 0
  const akvBalance = Number(useLoginUser().loginUser?.akvBalance.toAKV()) ?? 0
  const [status, setStatus] = useState<Props['status']>('Prepare')
  const [craft] = useCraftMutation()
  const [createdAm, setCreatedAm] = useState<Props['createdAm']>()
  const [createdAmId, setCreatedAmId] = useState<string>()
  const [usedCurrency, setUsedCurrency] = useState<CraftCurrencyType>(CraftCurrencyType.Teras)

  const router = useRouter()
  return {
    parts,
    status,
    createdAm,
    onClickClose,
    akvFee,
    akvBalance,
    terasFee,
    terasBalance,
    onCompleted,
    onClickInstall: () => {
      if (createdAmId) {
        router.push(PagePathService.arcadeMachineManagerShowCaseDetail(createdAmId))
      }
    },
    onClickCraft: () => {
      setStatus('Loading')
      craft({
        variables: {
          input: {
            rom: parts.rom?.type == 'AP' ? { tokenId: parts.rom?.id ?? '' } : { subCategory: parts.rom?.id },
            accumulator:
              parts.accumulator?.type === 'AP'
                ? { tokenId: parts.accumulator?.id ?? '' }
                : { subCategory: parts.accumulator?.id },
            upperCabinet:
              parts.upperCabinet?.type === 'AP'
                ? { tokenId: parts.upperCabinet?.id ?? '' }
                : { subCategory: parts.upperCabinet?.id },
            lowerCabinet:
              parts.lowerCabinet?.type === 'AP'
                ? { tokenId: parts.lowerCabinet?.id ?? '' }
                : { subCategory: parts.lowerCabinet?.id },
            usedCurrency,
          },
        },
      })
        .then((res) => {
          if (res.errors) {
            setStatus('Prepare')
            console.error(res.errors)
            alert('Error')
          } else {
            setStatus('Completed')
            setCreatedAmId(res.data?.craft.id)
            setCreatedAm({
              animationUrl: ArcadeMachineService.getCraftAmAnimationUrl({
                romSubCategory: res.data?.craft.game ?? '',
              }),
              name: ArcadeMachineService.getCraftAmName({
                romSubCategory: res.data?.craft.game ?? '',
                games,
              }),
            })
          }
        })
        .catch((error) => {
          console.error(error)
          alert('Error')
          setStatus('Prepare')
        })
    },
    usedCurrency,
    setUsedCurrency,
  }
}
